import {NgModule, ErrorHandler} from '@angular/core';

import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {BrowserModule, HAMMER_GESTURE_CONFIG} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {ReactiveFormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import {RouterModule} from '@angular/router';

import 'rxjs/Rx';
import 'hammerjs';		// only needs to be included here, not in lazy loaded modules

import {AllMaterialModule} from './all-material.module';
import {MatNativeDateModule} from '@angular/material';
import {GestureConfig} from '@angular/material';

import {SharedModule} from './modules/shared/shared.module';

// services
import {AuthService} from './services/auth.service';
import {AuthExistsGuard} from './services/auth-exists-guard.service';
import {AutoLoginService} from './services/auto-login.service';
import {CacheStorageService} from './services/cache-storage.service';
import {ConfigService} from './services/config.service';
import {CommunicationsService} from './services/communications.service';
import {DragDropService} from './services/drag-drop.service';
import {EmailService} from './services/email.service';
import {EventService} from './services/event.service';
import {FeedbackService} from './services/feedback.service';
import {FestivalService} from './services/festival.service';
import {GridService} from './services/grid.service';
import {LogService} from './services/log.service';
import {MyIndexedDbService} from './services/myindexeddb.service';
import {OauthService} from './services/oauth.service';
import {OrganizationService} from './services/organization.service';
import {PerfService} from './services/perf.service';
import {ReviewerFilmService} from './services/reviewer-film.service';
import {ReviewerImageService} from './services/reviewer-image.service';
import {ReviewerReviewService} from './services/reviewer-review.service';
import {TabService} from './services/tab.service';
import {UserService} from './services/user.service';
import {VersionService} from './services/version.service';
import {VolunteerService} from './services/volunteer.service';

// import {AngularIndexedDB} from './classes/angular2-indexeddb';
import {ItdExceptionHandler} from './classes/itd-exception';

// resovlers
import {AllEventsResolver} from './services/resolvers/all-events.resolver';
import {AllEventsAllOrganizationsResolver} from './services/resolvers/all-events-all-organizations.resolver';
import {AllFilmsResolver} from './services/resolvers/all-films.resolver';
import {AllGridsResolver} from './services/resolvers/all-grids.resolver';
import {AllOrganizationsResolver} from './services/resolvers/all-organizations.resolver';
import {AllReviewsResolver} from './services/resolvers/all-reviews.resolver';
import {AllUsersResolver} from './services/resolvers/all-users.resolver';
import {UserFilmsResolver} from './services/resolvers/user-films.resolver';
import {UserProfileResolver} from './services/resolvers/user-profile.resolver';
import {UserReviewsResolver} from './services/resolvers/user-reviews.resolver';

// components
import {ItdToolbarComponent} from './components/itd-toolbar/itd-toolbar.component';
import {LandingComponent} from './components/landing/landing.component';
import {NonceComponent} from './components/nonce/nonce.component';
import {OauthComponent} from './components/oauth/oauth.component';
import {OauthCallbackComponent} from './components/oauth-callback/oauth-callback.component';

import {RedirectComponent} from './components/redirect/redirect.component';

// directives  <-- nope, must be defined in lazy loaded module
// import {EmailValidatorDirective} from './directives/email-validator/email-validator.directive';
// import {ForbiddenValidatorDirective} from './directives/email-validator/email-validator.directive';
// import {NoWhitespaceDirective} from './directives/no-whitespace/no-whitespace.directive';



import {AppComponent} from './app.component';
import {routes} from './app.routes';


@NgModule({
	imports: [
		AllMaterialModule,
		BrowserAnimationsModule,
		BrowserModule,
		FormsModule,
		ReactiveFormsModule,
		HttpModule,
		RouterModule.forRoot(routes, { useHash: true }),
		MatNativeDateModule,

		SharedModule
	],
	declarations: [
		AppComponent,

		// components
		ItdToolbarComponent,
		LandingComponent,
		NonceComponent,
		OauthComponent,
		OauthCallbackComponent,
		RedirectComponent,

		// directives  <-- nope, must be defined in lazy loaded module
		// EmailValidatorDirective
		// ForbiddenValidatorDirective
		// NoWhitespaceDirective
	],
	providers: [
		// services
		AuthService,
		AuthExistsGuard,
		AutoLoginService,
		CacheStorageService,
		CommunicationsService,
		ConfigService,
		DragDropService,
		EmailService,
		EventService,
		FeedbackService,
		FestivalService,
		GridService,
		LogService,
		MyIndexedDbService,
		OauthService,
		OrganizationService,
		PerfService,
		ReviewerFilmService,
		ReviewerImageService,
		ReviewerReviewService,
		TabService,
		UserService,
		VersionService,
		VolunteerService,

		// resovlers
		AllEventsResolver,
		AllEventsAllOrganizationsResolver,
		AllFilmsResolver,
		AllGridsResolver,
		AllOrganizationsResolver,
		AllReviewsResolver,
		AllUsersResolver,
		UserFilmsResolver,
		UserProfileResolver,
		UserReviewsResolver,

		// external injectable classes
		// AngularIndexedDB,

		// https://github.com/angular/material2/issues/4278
		// Angular material has a bug with the import order of browserModule and angular material which causes Hammger gestures to get overridden.
		{ provide: HAMMER_GESTURE_CONFIG, useClass: GestureConfig },

// TODO!!! - put this back !!!   get a better solution for this !!!
		{provide: ErrorHandler, useClass: ItdExceptionHandler}
	],
	// entryComponents: [
	// 	DevDialogComponent,
	// 	LineupVoteDialogComponent
	// ],
	bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/app.module.ts